import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import "./ParkingApp.css"
import config from "react-global-configuration"
import localConfig from "./constants/config.json"
import localContent from "./constants/content.json"
import ScrollToTop from "./components/common/ScrollToTop"
import ReactHtmlParser from "react-html-parser"
// import registerServiceWorker from './registerServiceWorker';
//import BookingJourney from './components/BookingJourney'
const BookingJourney = React.lazy(() => import(/* webpackPrefetch: true */ "./components/BookingJourney"))

export default class ParkingApp {
  constructor() {
    this.init()
    this.content = {}
    return this
  }
  init() {
    const parkingContainer = document.querySelector("[data-parking-root]")
    if (parkingContainer) {
      this.setGlobalParkingConfig(parkingContainer)

      ReactDOM.render(
        <BrowserRouter>
          <ScrollToTop>
            <Suspense fallback={ReactHtmlParser(parkingContainer.innerHTML)}>
              <BookingJourney />
            </Suspense>
          </ScrollToTop>
        </BrowserRouter>,
        parkingContainer,
      )
      //      registerServiceWorker();
    }
  }

  setGlobalParkingConfig = (container) => {
    let configFromEpi = container.dataset.parkingRoot
    let currentConfig = {}
    if (!configFromEpi) {
      currentConfig = localConfig
    } else {
      currentConfig = JSON.parse(configFromEpi)
    }
    let contentFromEpi = container.dataset.parkingProductContent
    if (!contentFromEpi) {
      currentConfig.content = localContent
    } else {
      currentConfig.content = JSON.parse(contentFromEpi)
    }
    currentConfig.searchConfig = (container.dataset.inputSearch && JSON.parse(container.dataset.inputSearch)) || {}
    currentConfig.headerData = (container.dataset.modelJson && JSON.parse(container.dataset.modelJson)) || {}
    currentConfig.loginState = (container.dataset.loginState && JSON.parse(container.dataset.loginState)) || {}
    currentConfig.languages = (container.dataset.languages && JSON.parse(container.dataset.languages)) || {}
    currentConfig.consentContent =
      (container.dataset.parkingConsents && JSON.parse(container.dataset.parkingConsents)) ||
      JSON.parse(`
          {
              "header": "Det med småt...",
              "items": [
                  {
                      "consentId":"terms_and_condition",
                      "isRequired": true,
                      "isPreselected": false,
                      "header": "Handelsbetingelser",
                      "body": "Jeg godkender <a href='https://info.parkering.cph.dk/vilk%C3%A5r-cph-parkering' target='_blank'>handelsbetingelserne</a>"
                  },
                  {
                      "consentId":"Parking Consent",
                      "isRequired": false,
                      "isPreselected": true,
                      "header": "Mails om parkeringsprodukter",
                      "body": "Jeg er indforstået med, at Københavns Lufthavne A/S kan anvende min afgivne e-mailadresse til at sende reklame via elektronisk post for tilsvarende produkter og tjenesteydelser, som mit nuværende køb. Du kan til enhver tid tilbagekalde dit samtykke ved at anvende link i modtagne e-mails."
                  },
                  {
                      "consentId":"Marketing Consent",
                      "isRequired": false,
                      "isPreselected": false,
                      "header": "Mails om lufthavnen",
                      "body": "Jeg giver samtykke til at modtage markedsføring via elektronisk post, f.eks. e-mail, SMS, MMS, sociale medier, elektroniske platforme og apps fra Københavns Lufthavne A/S (”CPH”). Markedsføringen omfatter information om Københavns Lufthavn samt konkurrencer, events, fordelsprogrammer og parkeringsydelser udbudt af CPH. Markedsføringen omfatter også CPHs samarbejdspartnere, der driver spisesteder, butikker, hoteller og flyselskaber samt andre samarbejdspartnere, beliggende i eller ved Københavns Lufthavn eller som opererer fra Københavns Lufthavn. En liste over CPHs samarbejdspartnere og deres produkter er altid tilgængelig på cph.dk. Du kan altid tilbagekalde dit samtykke via link i kommunikationen. Læs i øvrigt <a href='https://www.cph.dk/vilkar-og-betingelser/privatliv' target='_blank'>CPHs privatlivspolitik</a>"
                  }]
          }`)
    currentConfig.locale = (document.body && document.body.dataset.language) || "da"
    currentConfig.reCaptchaSiteKey = container.dataset.reCaptchaSiteKey
    config.set(currentConfig)
  }
}
//window.parkingApp = new ParkingApp()
